import { FC } from 'react'
import { QueueWrapper } from './styles'
import { QueuePoint, QueueRate } from './components/QueueLineNew/QueueLineNew'
import { QueueView } from './components/QueueView/QueueView';
import QueueCreate from './components/QueueCreate';
import { Card } from '@brg/api';
import { getCurrentContextName } from 'supporting';
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";

export enum QueueMode {
    create = "create",
    edit = "edit",
    view = "view"
}

export interface QueueNewProps {
    activeCard?: Card
    currentQueuePoint: QueuePoint
    isBook?: boolean
    mode: QueueMode;
    rate: QueueRate;
    userQueuePoints: QueuePoint[];
    cardsLength: number
}

export const QueueNew: FC<QueueNewProps> = (props) => {
    const { activeCard, isBook, mode = QueueMode.view, rate, currentQueuePoint, userQueuePoints, cardsLength } = props
    const contextName = getCurrentContextName()   
    return <>
        {
            mode === QueueMode.create && contextName === 'artz'
                ? undefined
                : <QueueWrapper isBook={isBook} mode={mode}>
                    {
                        (mode === QueueMode.view) && <QueueView
                            isBook={isBook}
                            activeCard={activeCard}
                            currentQueuePoint={currentQueuePoint}
                            rate={rate}
                            userQueuePoints={userQueuePoints}
                        />
                    }
                    {mode === QueueMode.create && <QueueCreate
                        cardsLength={cardsLength}
                        isBook={isBook} />}
                </QueueWrapper>
        }
    </>
}
import { FC } from 'react'
import { QueueWrapper } from './styles'
import { QueuePoint, QueueRate } from './components/QueueLineNew/QueueLineNew'
import { QueueView } from './components/QueueView/QueueView';
import QueueCreate from './components/QueueCreate';
import { Card } from '@brg/api';
import { getCurrentContextName } from 'supporting';
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";

export enum QueueMode {
    create = "create",
    edit = "edit",
    view = "view"
}

export interface QueueNewProps {
    activeCard?: Card
    currentQueuePoint: QueuePoint
    isBook?: boolean
    mode: QueueMode;
    rate: QueueRate;
    userQueuePoints: QueuePoint[];
    cardsLength: number
}

export const QueueNew: FC<QueueNewProps> = (props) => {
    const { activeCard, isBook, mode = QueueMode.view, rate, currentQueuePoint, userQueuePoints, cardsLength } = props
    const contextName = getCurrentContextName()   
    return <>
        {
            mode === QueueMode.create && contextName === 'artz'
                ? undefined
                : <QueueWrapper isBook={isBook} mode={mode}>
                    {
                        (mode === QueueMode.view) && <QueueView
                            isBook={isBook}
                            activeCard={activeCard}
                            currentQueuePoint={currentQueuePoint}
                            rate={rate}
                            userQueuePoints={userQueuePoints}
                        />
                    }
                    {mode === QueueMode.create && <QueueCreate
                        cardsLength={cardsLength}
                        isBook={isBook} />}
                </QueueWrapper>
        }
    </>
}
